import { useEffect } from "react"

import { GridLayout } from "@/components/layout/GridLayout"

import { Tile } from "./Tile"
import { handleTearOut } from "./Tile/TearOut/handleTearOut"
import { useTearOutEntry } from "./Tile/TearOut/tearOut.state"
import {
  getInitView,
  TileView,
  useFilteredCurrencyPairs,
  useSelectedTileView,
} from "./tiles.state"

export const Tiles = () => {
  const currencyPairs = useFilteredCurrencyPairs()
  const selectedView = useSelectedTileView(getInitView())
  const tearOutEntry = useTearOutEntry()

  useEffect(() => {
    if (tearOutEntry) {
      const [symbol, tornOut] = tearOutEntry
      if (tornOut) {
        handleTearOut(symbol)
      }
    }
  }, [tearOutEntry])

  return (
    <GridLayout label="Lives Rates Tiles">
      {currencyPairs.map((currencyPair) => (
        <Tile
          key={currencyPair.symbol}
          currencyPair={currencyPair}
          showingChart={selectedView === TileView.Chart}
        />
      ))}
    </GridLayout>
  )
}
